import React, { useEffect, useState, useCallback } from "react";
import DatePicker from "react-datepicker";
import { fileTypes, prorityValues, statusTypes } from "./config";
import { getfilteroptionsdata, getUsers,getShortDescriptions,getReferenceIds,getDrg } from "../../api/Service";
import { formatCalenderDate } from "../../utils/util";
import { Accordion } from "react-bootstrap";
import _, { debounce, filter } from "lodash";
import userSearchIcon from "../../assests/search-icon.png"
import InfiniteScroll from "../../../codercompanion/components/infinite-scroll";
import { use } from "react";

const currentDate = formatCalenderDate(new Date());
const dateFormat = "yyyy-MM-dd"


const WorkFlowFilters = ({ showModal, onApply, onCancel,appliedFilters, filtersObj, setFiltersObj, openAccordion, setOpenAccordion }) => {
  // const permissions = JSON.parse(sessionStorage.getItem("permissions"));
  const permissions = JSON.parse(sessionStorage.getItem("permissions"));
  const superUserReadOnly = permissions?.super_user_readonly || false;
  const superUser = permissions?.super_user || false;
  const admin = permissions?.admin || false;
  let PrivilegedUser = ""
  if ("Privileged User" in permissions) {
    PrivilegedUser =  permissions["Privileged User"];
  } else {
    PrivilegedUser = false;
  }
  const userID = JSON.parse(sessionStorage.getItem("userId"));
  const workflow = permissions && Array.isArray(permissions.WorkflowCompanion) ? permissions.WorkflowCompanion[0] : "";
  const workflowReadOnly = permissions && Array.isArray(permissions.WorkflowCompanion) ? permissions.WorkflowCompanion[0] : "";

  const adminUser = permissions && permissions.admin; 
  const [coderNames, setCoderNames] = useState([]);
  const [insurerIdentifierList, setInsurerIdentifierList] = useState([]);
  const [toggleUnitConversion, setToggleUnitConversion] = useState(false);
  const [getAllAssineByUsers, setGetAllAssineByUsers] = useState([]);
  const [getAllAssineToUsers, setGetAllAssineToUsers] = useState([]);
  const [searchFilterAssgineeByUserName, setSearchFilterAssgineeByUserName] = useState("");
  const [searchFilterAssgineeToUserName, setSearchFilterAssgineeToUserName] = useState("");
  //new lines
  const [getAllShortDescriptons,setGetAllShortDescriptons] = useState([]);
  const [getAllReferenceIds,setGetAllReferenceIds] = useState([]);
  const [getAllDrg,setGetAllDrg] = useState([])
  const [searchFilterShortDescription,setSearchFilterShortDescription] = useState("");
  const [searchFilterReferenceId,setSearchFilterReferenceId] = useState("");
  const [searchDrg,setSearchDrg] = useState("")
  const [loadingUsers, setLoadingUsers] = useState(false);
  const [loadingReferenceIds,setLoadingReferenceIds] = useState(false);
  const [loadingShortDescriptions,setLoadingShortDescriptions] = useState(false)
  const [loadingDrg,setLoadingDrg] = useState(false)
  const [assgineFilterByCurrentPage, setAssgineFilterByCurrentPage ] = useState(1);
  const [assgineFilterToCurrentPage, setAssgineFilterToCurrentPage ] = useState(1);
  const [shortDescriptionFilterCurrentPage,setShortDescriptionFilterCurrentPage] = useState(1);
  const [referenceIdFilterCurrentPage,setReferenceIdFilterCurrentPage] = useState(1);
  const [drgFilterCurrentPage,setDrgFilterCurrentPage] = useState(1)
  const [specialityNames, setSpecialityNames] = useState([]);
  const [hasMoreAssgineByUsers, setHasMoreAssgineByUsers] = useState(true);
  const [hasMoreAssgineToUsers, setHasMoreAssgineToUsers] = useState(true);
  // reference id more pages
  const [hasMoreReferenceIds,setHasMoreReferenceIds] = useState(true);
  const [hasMoreShortDescriptions,setHasMoreShortDescriptions] = useState(true);
  const [hasMoreDrg,setHasMoreDrg] = useState(true)
  
  const handleCheckboxChange = (name, value) => {
    const currentIndex = filtersObj[name]?.indexOf(value);
    const newChecked = [...filtersObj[name]];
    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }
    setFiltersObj({...filtersObj, [name]: newChecked});

    if (openAccordion === null) {
      setOpenAccordion(name);
    }
  };
  const handleFiltersApply = () => {
    const filters = {
      ...appliedFilters,
        // ...filtersObj,
    
        insurer_identifier: filtersObj.insurer_identifier,
        priority_value: filtersObj.priority_value,
        file_type: filtersObj.file_type?.length > 0 ?filtersObj.file_type:appliedFilters.file_type||[],
        // short_description:filtersObj.short_description,
        // audit_ref_no:filtersObj.audit_ref_no,
        hcp_line_updated_at :filtersObj.hcp_line_updated_at,
        case_mix_speciality: filtersObj.case_mix_speciality,
        length_of_stay: filtersObj.length_of_stay,
        admission_date_from: formatCalenderDate(filtersObj.admission_date_from),
        admission_date_to: filtersObj.admission_date_from
          ? filtersObj.admission_date_to
            ? formatCalenderDate(filtersObj.admission_date_to)
            : currentDate
          : "",
        separation_date_from: formatCalenderDate(filtersObj.separation_date_from),
        separation_date_to: filtersObj.separation_date_from
          ? filtersObj.separation_date_to
            ? formatCalenderDate(filtersObj.separation_date_to)
            : currentDate
          : "",
          
          // audit_ref_no: filtersObj.audit_ref_no,
          // short_description: filtersObj.short_description,
          status:filtersObj.status,
          drg:filtersObj.drg

      };
     
    onApply(filters);
    setAssgineFilterToCurrentPage(1);
    setGetAllAssineToUsers([]);
    setAssgineFilterByCurrentPage(1);
    setGetAllAssineByUsers([]);
    onCancel();
  };

  const handleDateChange = (name, date) => {
    if(name === "admission_date_from" && !date){
      setFiltersObj({admission_date_from: null})
      return; 
    }
    if(name==="separation_date_from" && !date){
      setFiltersObj({separation_date_from: null})
      return;
    }
    if(name ==="length_of_stay"){
      setFiltersObj({ ...filtersObj, [name]: date})
    }else{
      setFiltersObj({...filtersObj, [name]: date})
    }
  };
 
  useEffect(() => {
    getfilteroptionsdata().then((res) => {
      const { coder_name, insurer_identifier, speciality } = res.data;
      //console.log(res.data,res,'Shell...',coder_name, insurer_identifier);
      const formatedCoderNames = coder_name.length>0 && coder_name.map((name, i) => ({
        id: i + 1,
        name: name[0].trim(),
      }));
      const formatedSpecialityNames = speciality.length > 0 && speciality.map((name, i) => ({
        id: i + 1,
        name: name[0].trim(),
      }));
      const formattedInsurerIdentifier = insurer_identifier.map((name, i) => ({
        id: i + 1,
        name: name[0],
      }));
      setCoderNames(formatedCoderNames);
      setSpecialityNames(formatedSpecialityNames);
      setInsurerIdentifierList(formattedInsurerIdentifier);
    }).catch((error)=>{
        if(error.response && (error.response.status===401 || error.response.status===403)){
          let errorMessage='';
          if(error.response.status===401){
            errorMessage='Please login again'
          }else if(error.response.status===403){
            errorMessage='You do not have permission to access this resource'
          }
          window.dispatchEvent(new CustomEvent('tokenExpired', {detail:{errorMessage}}));
        }
    });
  }, []);

  useEffect(() => {
    // USers API
    if(showModal) {
      document.body.style.overflowY = "hidden";
     
      getMoreShortDescriptions(1,true);
      getMoreReferenceIds(1,true)
    }
  }, [showModal])

  const handleUnitCoversionToggle =() =>{
    setToggleUnitConversion(!toggleUnitConversion)
  }

    const fetchFilterByUsers = useCallback(debounce((userName) => {
      
      setLoadingUsers(true);
      getUsers(userName, assgineFilterByCurrentPage)
        .then((res) => {
          if(res.message){
            // toast.error(res.message);
          }
          const { users } = res.data;
          setGetAllAssineByUsers(users);
        })
        .catch((err) =>{
          // console.log("No Users Found::", err.message)
          setGetAllAssineByUsers([]);
        }
        )
        .finally(() => setLoadingUsers(false));
    }, 500),
    []
  );

  const fetchFilterToUsers = useCallback(debounce((userName) => {
    setLoadingUsers(true);  
    getUsers(userName, assgineFilterToCurrentPage)
      .then((res) => {
        if(res.message){
          // toast.error(res.message);
        }
        const { users } = res.data;
        setGetAllAssineToUsers(users);
      })
      .catch((err) =>{
        // console.log("No Users Found::", err.message)
        setGetAllAssineToUsers([]);
      }
      )
      .finally(() => setLoadingUsers(false));
  }, 500),
  []
);
    const fetchFilterReferenceId = useCallback(debounce((referenceID) => {
      setLoadingReferenceIds(true);
      // console.log(referenceIdFilterCurrentPage)
      getReferenceIds(referenceID, referenceIdFilterCurrentPage)
        .then((res) => {
          if(res.message){
            // toast.error(res.message);
          }
          // console.log("filter reference id block")
         const filteredReferenceIds =res.data.audit_rules.audit_ref_no.flat();
        //  console.log(filteredReferenceIds)
          // const { users } = res.data;
          // setGetAllAssineByUsers(users);
          setGetAllReferenceIds(filteredReferenceIds)
        })
        .catch((err) =>{
          // console.log("No Reference Ids Found::", err.message)
          // setGetAllAssineByUsers([]);
          setGetAllReferenceIds([])
        }
        )
        .finally(() => setLoadingReferenceIds(false));
    }, 500),
    []
  );
  const fetchDrgData = useCallback(
    debounce((drgValue) => {
      setLoadingDrg(true);
  
      getDrg(drgValue, drgFilterCurrentPage)
        .then((res) => {
          if (res.message) {
            // handle message if needed
          }
  
          const filteredDrg = res.data?.audit_rules?.drg_code?.flat() || [];
          setGetAllDrg(filteredDrg);
        })
        .catch((err) => {
          console.error(err);
          setGetAllDrg([]);
        })
        .finally(() => {
          setLoadingDrg(false);
        });
    }, 500),
    [] 
  );
  const fetchFilterShortDescription = useCallback(debounce((shortDescription) => {
    setLoadingShortDescriptions(true);
  
    // console.log(shortDescriptionFilterCurrentPage);
    
    getShortDescriptions(shortDescription, shortDescriptionFilterCurrentPage)
      .then((res) => {
        if(res.message){
          // toast.error(res.message);
        }
        // console.log("shortDescription block")
       const filteredShortDescriptions =res.data.audit_rules.short_description.flat();
      //  console.log(filteredShortDescriptions)
        // const { users } = res.data;
        // setGetAllAssineByUsers(users);
        setGetAllShortDescriptons(filteredShortDescriptions)
      })
      .catch((err) =>{
        // console.log("No Reference Ids Found::", err.message)
        // setGetAllAssineByUsers([]);
        setGetAllShortDescriptons([])
      }
      )
      .finally(() => setLoadingShortDescriptions(false));
  }, 500),
  []
);

  // const getMoreAssigneByUsers = async(assgineFilterByCurrentPage, load_more) => {
  //   try {
  //     setLoadingUsers(true);
  //     const response = await getUsers(searchFilterAssgineeByUserName, assgineFilterByCurrentPage);
  //     const { users } = response.data;
  //     const mergedUsers = [
  //       ...new Map([...getAllAssineByUsers, ...users].map(item => [item.user_id, item])).values()
  //     ];
  //     if (load_more) {
  //       setGetAllAssineByUsers(mergedUsers);
  //     } else {
  //       setGetAllAssineByUsers(users);
  //     }
  //     setHasMoreAssgineByUsers(true);
  //     const newPage = assgineFilterByCurrentPage + 1;
  //     setAssgineFilterByCurrentPage(newPage);
  //   } catch (error) {
  //     console.log("Error fetching users:", error);
  //     setHasMoreAssgineByUsers(false);
  //     setAssgineFilterByCurrentPage(1);
  //     if (!load_more) {
  //       setGetAllAssineByUsers([]);
  //     }
  //   } finally {
  //     setLoadingUsers(false);
  //   }
  // };

  // const getMoreAssigneToUsers = async(assgineFilterToCurrentPage, load_more) => {
  //   try {
  //     setLoadingUsers(true);
  //     const response = await getUsers(searchFilterAssgineeToUserName, assgineFilterToCurrentPage);
  //     const { users } = response.data;
  //     const mergedUsers = [
  //       ...new Map([...getAllAssineToUsers, ...users].map(item => [item.user_id, item])).values()
  //     ];
  //     if (load_more) {
  //       setGetAllAssineToUsers(mergedUsers);
  //     } else {
  //       setGetAllAssineToUsers(users);
  //     }
  //     setHasMoreAssgineToUsers(true);
  //     const newPage = assgineFilterToCurrentPage + 1;
  //     setAssgineFilterToCurrentPage(newPage);
  //   } catch (error) {
  //     console.log("Error fetching users:", error);
  //     setHasMoreAssgineToUsers(false);
  //     setAssgineFilterToCurrentPage(1)
  //     if (!load_more) {
  //       setGetAllAssineByUsers([]);
  //     }
  //   } finally {
  //     setLoadingUsers(false);
  //   }
  // };
  const getMoreShortDescriptions = async (page, load_more) => {
    try {
      setLoadingShortDescriptions(true);
      const response = await getShortDescriptions(searchFilterShortDescription, shortDescriptionFilterCurrentPage);
      const shortDescriptions = response.data?.audit_rules.short_description.flat()|| [];
      const mergedShortDescriptions = [...new Set([...getAllShortDescriptons, ...shortDescriptions])];
      setGetAllShortDescriptons(load_more ? mergedShortDescriptions : shortDescriptions);
      if(shortDescriptions.length>0){
        setHasMoreShortDescriptions(true);
        const newPage = page+1;
        setShortDescriptionFilterCurrentPage(newPage)
      }
      else{
        setHasMoreShortDescriptions(false);
        setShortDescriptionFilterCurrentPage(1);
    
        // if (!load_more) setGetAllShortDescriptons([]);
      }

      // setShortDescriptionFilterCurrentPage(shortDescriptionFilterCurrentPage + 1);
    } catch (error) {
      console.error("Error fetching shortDescriptions:", error.message || error);
      

    } finally {
      setLoadingShortDescriptions(false);
    }
  };
  const getMoreDrg = async (drgCurrentpage,load_more)=>{
    try {
      setLoadingDrg(true);
      const response = await getDrg(searchDrg, drgCurrentpage);
      // console.log(response)
      const drg = response.data?.audit_rules?.drg_code?.flat() || [];
      const mergedDrg = [...new Set([...getAllDrg,...drg])]
      setGetAllDrg(load_more?mergedDrg:drg)
      if(drg.length >0){
        setHasMoreDrg(true)
        const newPage = drgCurrentpage+1;
        setDrgFilterCurrentPage(newPage)
      }
    } catch (error) {
      console.error("Error fetching shortDescriptions:", error.message || error);
    }finally {
      setLoadingDrg(false);
    }
  }
  const getMoreReferenceIds = async (referenceIdFilterCurrentPage, load_more) => {
    // console.log(referenceIdFilterCurrentPage, 'referenceIdFilterCurrentPage')
    try {
      setLoadingReferenceIds(true);
      const response = await getReferenceIds(searchFilterReferenceId, referenceIdFilterCurrentPage);
      const referenceIds = response.data?.audit_rules?.audit_ref_no?.flat() || [];
      const mergedReferenceIds = [...new Set([...getAllReferenceIds, ...referenceIds])];
      setGetAllReferenceIds(load_more ? mergedReferenceIds : referenceIds);
      if(referenceIds.length>0){
        // console.log("hasMoreData")
        setHasMoreReferenceIds(true);
        const newPage = referenceIdFilterCurrentPage+1
        setReferenceIdFilterCurrentPage(newPage);
      }
      else{
        setHasMoreReferenceIds(false);
       setReferenceIdFilterCurrentPage(1);
      // if (!load_more) setGetAllReferenceIds([]);
      }
     
      
    } catch (error) {
      console.error("Error fetching reference IDs:", error.message || error);
      
    } finally {
      setLoadingReferenceIds(false);
    }
  };
  


  const searchAssgineFilterByUsers = (event) => {
    const {value} = event.target
    setSearchFilterAssgineeByUserName(value);
    fetchFilterByUsers(value);
  };

  const searchAssgineFilterToUsers = (event) => {
    const {value} = event.target
    setSearchFilterAssgineeToUserName(value);
    fetchFilterToUsers(value);
  };
  
  const searchShortDescription = (event) => {
    const {value} = event.target
    // console.log(value)

    setSearchFilterShortDescription(value);
    setShortDescriptionFilterCurrentPage(1);
    fetchFilterShortDescription(value);
  };
  const searchDrgData = (event)=>{
    const {value} = event.target;
    setSearchDrg(value)
    setDrgFilterCurrentPage(1)
    fetchDrgData(value)
  }


  const searchReferenceId = (event) => {
    const {value} = event.target
    // console.log(value)
    setSearchFilterReferenceId(value);
    setReferenceIdFilterCurrentPage(1);
    fetchFilterReferenceId(value);
  };


  const toggleAccordion = (id) => {
    // console.log(id)
    if(id === "8"){
      
      getMoreDrg(1, true);
      setHasMoreDrg(true)
     
      setSearchDrg("")
      setGetAllDrg([])
      if(searchDrg.length >= 0){
        getMoreDrg(1, true)
      }
      
    }
    if(id === "2"){
      // console.log(1,"accordian")
      // getMoreReferenceIds(1, true);
      getMoreReferenceIds(1, true);
      setHasMoreReferenceIds(true);
      setSearchFilterReferenceId("");
      setGetAllReferenceIds([]);
      if(searchFilterReferenceId.length >= 0){
        getMoreReferenceIds(1, true);
      }
    }
    if(id === "3"){
      // console.log("shortdesc opened")
      // getMoreShortDescriptions(1, true);
      setSearchFilterShortDescription("");
      getMoreShortDescriptions(1, true);
      setHasMoreShortDescriptions(true);
      setGetAllShortDescriptons([]);
      if(searchFilterShortDescription.length >= 0){
          getMoreShortDescriptions(1, true);
      }
    }
    setSearchFilterShortDescription("");
    setSearchFilterReferenceId("")
    // setGetAllShortDescriptons([]);
    // setGetAllReferenceIds([])
    setOpenAccordion((prevOpenAccordion) => {
      return prevOpenAccordion === id ? null : id;
    });
  };

  return (
    showModal&&(<div
      className="modalfilters"
      
      tabIndex="-1"
    >
      <div
        className="modalfilters-section"
      >
        <div
          className="modalfilters-content"
          // style={{ width: "1000px", margin: "auto", background: "white", borderRadius: "5px", position: "relative"}}
          
        >
          <div className="filters-modal-header">
          <h3 className="filter-title">Filters</h3>
          <button className="btn-close" 
              onClick={() => {
                onCancel();
                setAssgineFilterToCurrentPage(1);
                setAssgineFilterByCurrentPage(1);
              }}
              ></button>
          </div>

          <div className="filter-modal-body">
            <div className="d-flex">
              {/* File Type */}
              <div className="left-filter">
                {/* File Type */}
                <Accordion defaultActiveKey={null} flush className="filters-border">
                  <Accordion.Item eventKey="1" className="item_accordion"  >
                    <Accordion.Header className="header_accordion" onClick={() => toggleAccordion("1")} active={openAccordion === "1"}>File Type</Accordion.Header>
                    {fileTypes.length > 0 ? fileTypes.map((fileType) => (
                      <Accordion.Body key={fileType} className="body_accordion">
                        <input
                          className="accordion-input"
                          type="checkbox"
                          id="fileType1"
                          onChange={() =>
                          handleCheckboxChange("file_type", fileType)}
                          checked={filtersObj.file_type?.includes(fileType) || false}
                        />
                        <label className="accordion-label" htmlFor="fileType1">{fileType}</label>
                      </Accordion.Body>
                    )): 
                    <Accordion.Body className="body_accordion">No Data Found</Accordion.Body>
                    }
                  </Accordion.Item>
                  {/* Refrence Id filter Accordian */}
                  {/* <Accordion.Item eventKey="2" className="item_accordion_user"  >
                    <Accordion.Header className="header_accordion" onClick={() => toggleAccordion("2") }active={openAccordion === "2"}>Audit Rule Reference Id</Accordion.Header>
                    <Accordion.Body className="">
                    <div className="assigne-search-filter-section">
                      <img className="assigne-search-icon" src={userSearchIcon} alt={"userSearchIcon"} />
                      <input
                        className="assgine-search-filter-input"
                        type="text"
                        value={searchFilterReferenceId}
                        onChange={searchReferenceId}
                        placeholder="Search by Audit Rule Reference Id"
                        onClick={(e)=>e.stopPropagation()}
                      />
                    </div>
                    <InfiniteScroll
                      className="assgine-modal-body"
                      hasData={hasMoreReferenceIds}
                      loadMore={() => getMoreReferenceIds(referenceIdFilterCurrentPage, true)}
                      isLoading={loadingReferenceIds}
                    >
                    {getAllReferenceIds?.length > 0 ? getAllReferenceIds?.map((item,index) => (
                      <Accordion.Body key={index} className="body_accordion1">
                        <input
                          type="checkbox"
                          className="accordion-input"
                          id={`audit_ref_no-${item}`}
                          onChange={() => handleCheckboxChange("audit_ref_no", item)}
                          checked={filtersObj.audit_ref_no?.includes(item)}
                          onClick={(e)=>e.stopPropagation()}
                        />
                        <label className="accordion-label" htmlFor={`audit_ref_no-${item}`} onClick={(e)=>e.stopPropagation() }>{item}</label>
                      </Accordion.Body>
                    )) : <Accordion.Body>No Data Found</Accordion.Body>}
                    </InfiniteScroll>
                    </Accordion.Body>
                  </Accordion.Item> */}
                  {/* Short Description */}
                  {/* <Accordion.Item eventKey="3" className="item_accordion_user"  >
                    <Accordion.Header className="header_accordion" onClick={() => toggleAccordion("3")} active={openAccordion === "3"}>Audit Rule Short Description</Accordion.Header>
                    <Accordion.Body className="body_accordion1">
                    <div className="assigne-search-filter-section" style={{marginTop:"10px"}}>
                      <img className="assigne-search-icon" src={userSearchIcon} alt={"userSearchIcon"} />
                      <input
                        className="assgine-search-filter-input"
                        type="text"
                        value={searchFilterShortDescription}
                        onChange={searchShortDescription}
                        placeholder="Search by Audit Rule Short Description"
                        onClick={(e)=>e.stopPropagation()}
                      />
                    </div>
                    <InfiniteScroll
                      className="assgine-modal-body"
                      hasData={hasMoreShortDescriptions}
                      loadMore={() => getMoreShortDescriptions(shortDescriptionFilterCurrentPage, true)}
                      isLoading={loadingShortDescriptions}
                    >
                    {getAllShortDescriptons?.length > 0 ? getAllShortDescriptons?.map((item,index) => (
                      <Accordion.Body key={index} className="body_accordion1">
                        <input
                          type="checkbox"
                          className="accordion-input"
                          id={`short_description-${item}`}
                          onChange={() => handleCheckboxChange("short_description", item)}
                          checked={filtersObj.short_description?.includes(item)}
                          onClick={(e)=>e.stopPropagation()}
                        />
                        <span className="accordion-label" htmlFor={`reference_id-${item}`}>{item}</span>
                      </Accordion.Body>
                    )) : <Accordion.Body>No Data Found</Accordion.Body>}
                    </InfiniteScroll>
                    </Accordion.Body>
                  </Accordion.Item> */}
                  
                {/* Priority Value */}
                  <Accordion.Item eventKey="4" className="item_accordion" >
                    <Accordion.Header className="header_accordion" onClick={() => toggleAccordion("4")} active={openAccordion === "4"}>Priority Value</Accordion.Header>
                      <Accordion.Body className="">
                      <button className="toggle-conversion-btn" onClick={handleUnitCoversionToggle}>$ / NWAU</button>
                      { prorityValues.length > 0 ? prorityValues.map((priority) => (
                        <Accordion.Body key={priority.label} className="body_accordion1">
                          <input
                          type="checkbox"
                          className="accordion-input"
                          id={`priority${priority.value}`}
                          onChange={() =>handleCheckboxChange("priority_value", priority.value)}
                          checked={ filtersObj.priority_value?.includes(priority.value) }
                          
                          />
                          <label className="accordion-label" htmlFor={`priority${priority.value}`}>
                            {toggleUnitConversion? priority.label:priority.nwunits || priority.label}
                          </label>
                        </Accordion.Body>
                      )): 
                      <Accordion.Body>No Data Found</Accordion.Body>
                      }
                      </Accordion.Body>
                  </Accordion.Item>
                {/* Status */}
                  <Accordion.Item eventKey="3" className="item_accordion" onClick={() => toggleAccordion("5")} active={openAccordion === "3"}>
                    <Accordion.Header className="header_accordion">Status</Accordion.Header>
                      {statusTypes.length > 0 ? statusTypes.map((type) => (
                        <Accordion.Body key={type} className="body_accordion">
                        <input
                          type="checkbox"
                          className="accordion-input"
                          id={`statusType-${type}`}
                          onChange={() => handleCheckboxChange("status", type)}
                          checked={filtersObj.status?.includes(type)}
                        />
                         <label className="accordion-label" htmlFor={`statusType-${type}`}>{type}</label>
                         </Accordion.Body>
                      )) : 
                      <Accordion.Body>No Data Found</Accordion.Body>
                      }
                  </Accordion.Item>
                {/* Coded By */}
                  {/* <Accordion.Item eventKey="4" className="item_accordion" onClick={() => toggleAccordion("4")} active={openAccordion === "4"}>
                    <Accordion.Header className="header_accordion">Coded By</Accordion.Header>
                    {coderNames.length > 0 ? coderNames?.map((item) => (
                      <Accordion.Body key={item.id} className="body_accordion">
                        <input
                          type="checkbox"
                          className="accordion-input"
                          id={`codedby-${item.id}`}
                          value={item.id}
                          checked={filtersObj.coder_name?.includes(item.name)}
                          onChange={(e) =>
                            handleCheckboxChange("coder_name", item.name)
                          }
                        />
                        <label className="accordion-label" htmlFor={`codedby-${item.id}`}style={{ marginLeft: "8px" }}>{item.name}</label>
                      </Accordion.Body>
                    )):
                    <Accordion.Body className="body_accordion">No Data Found</Accordion.Body>
                    }
                  </Accordion.Item> */}
                {/* Insurer Identifier */}
                  <Accordion.Item eventKey="5" className="item_accordion" >
                    <Accordion.Header className="header_accordion" onClick={() => toggleAccordion("5")} active={openAccordion === "5"}>Insurer Identifier</Accordion.Header>
                      {insurerIdentifierList.length > 0 ? insurerIdentifierList.map((item) => (
                        <Accordion.Body key={item.id} className="body_accordion">
                          <input
                            type="checkbox"
                            className="accordion-input"
                            id={`insurer-${item.id}`}
                            value={item.id}
                            checked={filtersObj.insurer_identifier?.includes(item.name)}
                            onChange={(e) =>handleCheckboxChange("insurer_identifier", item.name)}
                          />
                          <label className="accordion-label" htmlFor={`insurer-${item.id}`}style={{ marginLeft: "8px" }}>{item.name}</label>
                        </Accordion.Body>
                      )) : 
                        <Accordion.Body>No Data Found</Accordion.Body>
                      }    
                  </Accordion.Item>
                {/* specifications */}
                  <Accordion.Item eventKey="6" className="item_accordion" >
                    <Accordion.Header className="header_accordion" onClick={() => toggleAccordion("6")} active={openAccordion === "6"} >Case Mix Speciality</Accordion.Header>
                    {specialityNames.length > 0 ? specialityNames.map((item) => (
                      <Accordion.Body key={item.name} className="body_accordion">
                        <input
                          type="checkbox"
                          className="accordion-input"
                          id={`case_mix_speciality-${item.name}`}
                          onChange={() => handleCheckboxChange("case_mix_speciality", item.name)}
                          checked={filtersObj.case_mix_speciality?.includes(item.name)}
                        />
                        <label className="accordion-label" htmlFor={`case-${item.name}`}>{item.name}</label>
                      </Accordion.Body>
                    )) : <Accordion.Body>No Data Found</Accordion.Body>}
                  </Accordion.Item>
                  {/* DRG */}
                  <Accordion.Item eventKey="8" className="item_accordion"  >
                    <Accordion.Header className="header_accordion" onClick={() => toggleAccordion("8")} active={openAccordion === "8"}>DRG</Accordion.Header>
                    <Accordion.Body className="body_accordion">
                    <div className="assigne-search-filter-section" style={{marginTop:"10px"}}>
                      <img className="assigne-search-icon" src={userSearchIcon} alt={"userSearchIcon"} />
                      <input
                        className="assgine-search-filter-input"
                        type="text"
                        value={searchDrg}
                        onChange={searchDrgData}
                        placeholder="Search by DRG value"
                        onClick={(e)=>e.stopPropagation()}
                      />
                    </div>
                    <InfiniteScroll
                      className="assgine-modal-body"
                      hasData={hasMoreDrg}
                      loadMore={() => getMoreDrg(drgFilterCurrentPage, true)}
                      isLoading={loadingDrg}
                    >
                    {getAllDrg?.length > 0 ? getAllDrg?.map((item,index) => (
                      <Accordion.Body key={index} className="body_accordion1">
                        <input
                          type="checkbox"
                          className="accordion-input"
                          id={`drg-${index}`}
                          onChange={() => handleCheckboxChange("drg", item)}
                          checked={filtersObj.drg?.includes(item)}
                          onClick={(e)=>e.stopPropagation()}
                        />
                        <span className="accordion-label" htmlFor={`drg-${index}`}>{item}</span>
                      </Accordion.Body>
                    )) : <Accordion.Body>No Data Found</Accordion.Body>}
                    </InfiniteScroll>
                    </Accordion.Body>
                  </Accordion.Item>
                {/* assign By */}
                  {/* <Accordion.Item eventKey="7" className="item_accordion_user" onClick={() => toggleAccordion("7")} active={openAccordion === "7"}>
                    <Accordion.Header className="header_accordion">Assign By</Accordion.Header>
                    <Accordion.Body className="">
                    <div className="assigne-search-filter-section">
                      <img className="assigne-search-icon" src={userSearchIcon} alt={"userSearchIcon"} />
                      <input
                        className="assgine-search-filter-input"
                        type="text"
                        value={searchFilterAssgineeByUserName}
                        onChange={searchAssgineFilterByUsers}
                        placeholder="Search by Username"
                      />
                    </div>
                    <InfiniteScroll
                      className="assgine-modal-body"
                      hasData={hasMoreAssgineByUsers}
                      loadMore={() => getMoreAssigneByUsers(assgineFilterByCurrentPage, true)}
                      isLoading={loadingUsers}
                    >
                    {getAllAssineByUsers?.length > 0 ? getAllAssineByUsers?.map((item) => (
                      <Accordion.Body key={item?.user_id} className="body_accordion1">
                        <input
                          type="checkbox"
                          className="accordion-input"
                          id={`assigned_by-${item?.username}`}
                          onChange={() => handleCheckboxChange("assigned_by", item?.user_id)}
                          checked={filtersObj.assigned_by?.includes(item?.user_id)}
                        />
                        <label className="accordion-label" htmlFor={`assigned_by-${item?.username}`}>{item?.username}</label>
                      </Accordion.Body>
                    )) : <Accordion.Body>No Data Found</Accordion.Body>}
                    </InfiniteScroll>
                    </Accordion.Body>
                  </Accordion.Item> */}
                {/* Assign To */}
                  {/* {(admin || superUser || superUserReadOnly) && (
                    <Accordion.Item eventKey="8" className="item_accordion_user" onClick={() => toggleAccordion("8")} active={openAccordion === "8"}>
                    <Accordion.Header className="header_accordion">Assign To</Accordion.Header>
                    <Accordion.Body className="">
                    <div className="assigne-search-filter-section">
                      <img className="assigne-search-icon" src={userSearchIcon} alt={"userSearchIcon"} />
                      <input
                        className="assgine-search-filter-input"
                        type="text"
                        value={searchFilterAssgineeToUserName}
                        onChange={searchAssgineFilterToUsers}
                        placeholder="Search by Username"
                      />
                    </div>
                    <InfiniteScroll
                      className="assgine-modal-body"
                      hasData={hasMoreUsers}
                      loadMore={() => getMoreAssigneToUsers(assgineFilterToCurrentPage, true)}
                      isLoading={loadingUsers}
                    >
                      
                    {getAllAssineToUsers?.length > 0 ? getAllAssineToUsers?.map((item) => (
                      <Accordion.Body key={item?.user_id} className="body_accordion1">
                        <input
                          type="checkbox"
                          className="accordion-input"
                          id={`assigned_to-${item?.username}`}
                          onChange={() => handleCheckboxChange("assigned_to", item?.user_id)}
                          checked={filtersObj.assigned_to?.includes(item?.user_id)}
                        />
                        <label className="accordion-label" htmlFor={`assigned_to-${item?.username}`}>{item?.username}</label>
                      </Accordion.Body>
                    )): <Accordion.Body>No Data Found</Accordion.Body>}
                    </InfiniteScroll>
                    </Accordion.Body>
                    </Accordion.Item>
                  )} */}
                  
                 {/* {(admin || superUser || superUserReadOnly) &&  <Accordion.Item eventKey="8" className="item_accordion_user" onClick={() => toggleAccordion("8")} active={openAccordion === "8"}>
                    <Accordion.Header className="header_accordion">Assign To</Accordion.Header>
                    <Accordion.Body className="">
                    <div className="assigne-search-filter-section">
                      <img className="assigne-search-icon" src={userSearchIcon} alt={"userSearchIcon"} />
                      <input
                        className="assgine-search-filter-input"
                        type="text"
                        value={searchFilterAssgineeToUserName}
                        onChange={searchAssgineFilterToUsers}
                        placeholder="Search by Username"
                      />
                    </div>
                    <InfiniteScroll
                      className="assgine-modal-body"
                      hasData={hasMoreAssgineToUsers}
                      loadMore={() => getMoreAssigneToUsers(assgineFilterToCurrentPage, true)}
                      isLoading={loadingUsers}
                    >
                      
                    {getAllAssineToUsers?.length > 0 ? getAllAssineToUsers?.map((item) => (
                      <Accordion.Body key={item?.user_id} className="body_accordion1">
                        <input
                          type="checkbox"
                          className="accordion-input"
                          id={`assigned_to-${item?.username}`}
                          onChange={() => handleCheckboxChange("assigned_to", item?.user_id)}
                          checked={filtersObj.assigned_to?.includes(item?.user_id)}
                        />
                        <label className="accordion-label" htmlFor={`assigned_to-${item?.username}`}>{item?.username}</label>
                      </Accordion.Body>
                    )): <Accordion.Body>No Data Found</Accordion.Body>}
                    </InfiniteScroll>
                    </Accordion.Body>
                    </Accordion.Item>
                  } */}



               {/* <Accordion.Item eventKey="9" className="item_accordion_user" onClick={() => toggleAccordion("9")} active={openAccordion === "9"}>
                    <Accordion.Header className="header_accordion">Audit filters</Accordion.Header>
                    <Accordion.Body className="">
                    <div className="assigne-search-filter-section">
                      <img className="assigne-search-icon" src={userSearchIcon} alt={"userSearchIcon"} />
                      <input
                        className="assgine-search-filter-input"
                        type="text"
                        value={searchFilterAssgineeToUserName}
                        onChange={searchAssgineFilterToUsers}
                        placeholder="Search by Username"
                      />
                    </div>
                    <InfiniteScroll
                      className="assgine-modal-body"
                      hasData={hasMoreAssgineToUsers}
                      loadMore={() => getMoreAssigneToUsers(assgineFilterToCurrentPage, true)}
                      isLoading={loadingUsers}
                    >
                      
                    {getAllAssineToUsers?.length > 0 ? getAllAssineToUsers?.map((item) => (
                      <Accordion.Body key={item?.user_id} className="body_accordion1">
                        <input
                          type="checkbox"
                          className="accordion-input"
                          id={`assigned_to-${item?.username}`}
                          onChange={() => handleCheckboxChange("assigned_to", item?.user_id)}
                          checked={filtersObj.assigned_to?.includes(item?.user_id)}
                        />
                        <label className="accordion-label" htmlFor={`assigned_to-${item?.username}`}>{item?.username}</label>
                      </Accordion.Body>
                    )): <Accordion.Body>No Data Found</Accordion.Body>}
                    </InfiniteScroll>
                    </Accordion.Body>
                    </Accordion.Item> */}

                </Accordion>
              </div>

              {/* Dates */}
              <div className="dates-wrapper">
                <h6 className="text-start">Admission Date:</h6>
                <div className="date-picker-wrapper">
                  <DatePicker
                    selected={filtersObj.admission_date_from}
                    onChange={(dt) => handleDateChange("admission_date_from", dt)}
                    dateFormat={dateFormat}
                    placeholderText="From"
                    maxDate={currentDate}
                  />
                   <div
                     className = {`${!filtersObj.admission_date_from ? "datepicker-tooltip" : ""}`}
                     data-title={"'To date' cannot be selected until 'From date' is selected"}
                   >
                  <DatePicker
                    selected={filtersObj.admission_date_to}
                    onChange={(dt) => handleDateChange("admission_date_to", dt)}
                    dateFormat={dateFormat}
                    placeholderText="To"
                    disabled={!filtersObj.admission_date_from}
                    minDate={filtersObj.admission_date_from}
                    maxDate={currentDate}
                    />
                  </div>
                </div>
                <h6 className="text-start date-header">Separation Date:</h6>
                <div className="date-picker-wrapper">
                  <DatePicker
                    selected={filtersObj.separation_date_from}
                    onChange={(dt) => handleDateChange("separation_date_from", dt)}
                    dateFormat={dateFormat}
                    placeholderText="From"
                    minDate={filtersObj.admission_date_from}
                    maxDate={currentDate}
                  />
                  <div
                   className = {`${!filtersObj.separation_date_from ? "datepicker-tooltip" : ""}`}
                   data-title={"'To date' cannot be selected until 'From date' is selected"}
                  >
                  <DatePicker
                    selected={filtersObj.separation_date_to}
                    onChange={(dt) => handleDateChange("separation_date_to", dt)}
                    dateFormat={dateFormat}
                    placeholderText="To"
                    disabled={!filtersObj.separation_date_from}
                    minDate={filtersObj.separation_date_from}
                    maxDate={currentDate}
                    />
                  </div>
                </div>
                <div>
                <h6 className="text-start date-header">LOS</h6>
                <div className="">
                <input 
                  type="number"
                  className="filter-input"
                  value={filtersObj.length_of_stay || ""}
                  placeholder="Los"
                  onChange={(e) => {
                  const newValue = e.target.value === "" || isNaN(e.target.value) ? [] : [Number(e.target.value)];
                  handleDateChange("length_of_stay", newValue);
                  }}
                />
                </div>
                </div>
              </div>
            </div>
          </div>
          <div className="filter-footer">
            <button
              type="button"
              className="filter-btn-cancel"
              onClick={onCancel}
            >
              Close
            </button>
            <button
              type="button"
              className="filter-btn-save"
              // style={{ backgroundColor: "#4298CD", border: "none" }}
              onClick={handleFiltersApply}
            >
              {/* <span>
              <img src={filtertick} alt="Filter Tick" />
            </span>{" "} */}
              Apply
            </button>
          </div>
        </div>
      </div>
    </div>
  ));
};

export default WorkFlowFilters;
 